<template>
    <div>
        <div v-for="(question, i) in questions" :key="i">
            <div v-if="!question.answer_parent_id">
                <p>{{ question.question }}</p>
                <div v-if="question.type == 0">
                    <div v-for="(answer, y) in question.answers_possibilities" :key="y">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="question-checkboxes[]" id="-checkbox" />
                            <label class="form-check-label" for="question-checkbox">{{ answer.possibility }}</label>
                        </div>
                    </div>
                </div>
                <div v-if="question.type == 1">
                    <div v-for="(answer, y) in question.answers_possibilities" :key="y">
                        <div class="radio-group">
                            <input class="form-check-input" type="radio" name="question-radio" id="question-radio" />
                            <label class="form-check-label" for="question-checkbox">{{ answer.possibility }}</label>
                        </div>
                        <div v-for="(quest, n) in questions" :key="n">
                            <div v-if="quest.answer_parent_id == answer.id">
                                <!-- <p>{{ quest.question }}</p> -->
                                <survey-fo :questions="[quest]"></survey-fo>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="question.type == 2">
                    <input class="form-control" type="text" name="question-text" placeholder="Votre réponse.." />
                </div>
                <div v-if="question.type == 3">
                    <input class="form-control" type="number" name="question-number" placeholder="Votre réponse.." value="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SurveyAnswer',
    props: ['questions'],
    data: () => ({
        index: 0,
    }),
    mounted() {},
    methods: {},
}
</script>
